<!--新增客户列表-->
<template>
    <div>
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机/会员卡号"
                left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div class="select-box flex flex-y-center flex-start">
            <div v-if="postId==1||postId==3||postId=='1472787652026766338'||postId=='1472787652026765367'||postId=='1472787652026765362'"
                class="select-item mr-30 flex-between flex-y-center" @click="selectEmployeePopup">
                <div class="select-tit">{{ checkedEmployee && checkedEmployee.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
            <div class="select-item mr-30 flex-between flex-y-center" @click="selectCardPopup">
                <div class="select-tit">{{ checkedCard && checkedCard.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
            <div class="select-item flex flex-between flex-y-center" @click="selectTimePopup">
                <div class="select-tit">{{dateTxt}}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div>
        <div class="add-customer">
            <span> 新办卡数：</span>
            <span class="add-customer-number">{{newCardData.cardNum}}</span>
        </div>
        <div class="list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <!-- 下拉刷新 -->
                <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="onLoad"
                    :offset="20" :immediate-check="false">
                    <div class="customer-list" v-for="(item, index) in newCardList" :key="index"
                        @click="toDetail(item.id,item.mobile)">
                        <div class="flex-row">
                            <img class="customerHeadPortrait" referrerpolicy="no-referrer" alt=""
                                :src="item.avatar?item.avatar:'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" />
                            <div class="customer-info flex-1">
                                <div class="customer-name">{{item.name}}
                                </div>
                                <div class="churn-time">{{item.createDate}}</div>
                            </div>
                            <!-- <div class="arrow_box"> -->
                            <img class="arrow_right" referrerpolicy="no-referrer" alt=""
                                src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" />
                            <!-- </div> -->
                        </div>
                        <div class="customer-remark flex-between flex-y-center">
                            <div class="flex-between flex-y-center">
                                <span class="sale-name">充值：</span>
                                <span class="sale-number">{{item.amount}}</span>
                            </div>
                            <div class="flex-between flex-y-center">
                                <span class="sale-name">入会：</span>
                                <span class="sale-number">{{item.cardName}}</span>
                            </div>
                            <div class="flex-between flex-y-center">
                                <span class="sale-name">开单：</span>
                                <span class="sale-number">{{item.creatorName}}</span>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
            <van-popup v-model="showEmployeePopup" round position="bottom" closeable class="popup">
                <picker title="全部员工" v-model="checkedEmployee" :list="employeeList" @change="onEmployeeChange"></picker>
            </van-popup>
            <van-popup v-model="showCardPopup" round position="bottom" closeable class="popup">
                <picker title="卡等级" v-model="checkedCard" :list="cardList" @change="onCardChange"></picker>
            </van-popup>
            <van-popup v-model="showTimePopup" round position="bottom" closeable class="popup">
                <date-picker v-model="dateType" @submit="handleDate" :pickerType="pickerType"></date-picker>
            </van-popup>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";
import DatePicker, { getDateText, getFormatTime, PICKER_TYPE } from '@/components/DatePicker';
import Picker from '@/components/Picker';
import { Search, Toast } from "vant";
import { getCookie } from '@/utils'


export default {
    name: "newCardList",
    components: {
        [Search.name]: Search, DatePicker, Picker
    },
    data() {
        return {
            pickerType: PICKER_TYPE.DAY,// 日期类型
            dateType: '1', // 日期
            beginMonth: '', // 开始日期
            endMonth: '', // 结束日期
            showTimePopup: false,// 选择时间弹窗
            showEmployeePopup: false,// 选择员工弹窗
            showCardPopup: false,// 选择卡弹窗
            searchStr: '',  // 搜索条件
            page: 1,       // 当前页
            limit: 10,       // 每页多少条
            total: 0,     // 列表总条数
            newCardList: [],    // 列表
            newCardData: [],    // 数据
            loading: false,    // 加载
            finished: false,    // 结束加载
            refreshing: false,   // 刷新
            cardList: [],// 卡列表
            checkedCard: null,//所选卡
            employeeList: [], // 员工
            checkedEmployee: null,//所选员工
            postId: 0, // 岗位
        };
    },
    computed: {
        dateTxt() {
            return getDateText(this.dateType, this.beginMonth, this.endMonth, this.pickerType)
        }
    },
    mounted() {
        this.postId = getCookie('postId') || localStorage.getItem('postId');
        this.init()
    },
    methods: {
        async init() {
            await this.getEmpList()
            await this.getCardList()
            this.onLoad()

        },
        onLoad() {
            this.loading = true
            const beginDate = getFormatTime(this.beginMonth, this.pickerType)
            const endDate = getFormatTime(this.endMonth, this.pickerType)
            request({
                url: "/custCount/newMemberDetailPage?beginMonth=" + beginDate +
                    "&endMonth=" + endDate +
                    "&dateType=" + this.dateType +
                    '&memberNameAndMobile=' + this.searchStr +
                    '&limit=' + this.limit +
                    '&page=' + this.page + '&levelCode=' + this.checkedCard.id + '&creator=' + this.checkedEmployee.id,
                method: "get",
            })
                .then((res) => {
                    this.newCardData = res.data
                    this.newCardList = this.page == 1 ? res.data.data.list : this.newCardList.concat(res.data.data.list);
                    this.page += 1;
                    this.total = res.data.data.total;

                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    this.refreshing = false;
                    if (this.newCardList.length >= this.total) {
                        this.finished = true;
                    }
                });
        },
        // 获取员工列表
        getEmpList() {
            return request({
                url: "/workEmployee/getEmployeeList",
                method: "get",
            })
                .then((res) => {
                    this.employeeList = res.data
                    this.checkedEmployee = this.employeeList[0] //默认全部

                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 获取卡列表
        getCardList() {
            return request({
                url: "/dict/type/cardLevel",
                method: "get",
            })
                .then((res) => {
                    this.cardList = res.data
                    this.checkedCard = this.cardList[0] //默认全部

                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        //搜索
        onSearch() {
            this.page = 1
            this.onLoad();
        },
        onRefresh() {
            this.page = 1
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.newCardList = [];
            this.refreshing = false;
            this.onLoad();
        },
        //查看详情
        toDetail(custId, phone) {
            this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
        },
        //清除搜索
        selClear() {
            this.searchStr = "";
            this.onRefresh()
        },
        // 弹窗
        selectEmployeePopup() {
            this.showEmployeePopup = true
        },
        selectCardPopup() {
            this.showCardPopup = true
        },
        selectTimePopup() {
            this.showTimePopup = true
        },
        // 筛选相关
        handleDate(id, begin, end) {
            this.showTimePopup = false
            this.dateType = id
            if (!id) {
                this.beginMonth = begin
                this.endMonth = end
            } else {
                this.beginMonth = ''
                this.endMonth = ''
            }
            this.onRefresh()
        },
        onEmployeeChange(data) {
            this.checkedEmployee = data
            this.showEmployeePopup = false
            this.onRefresh()
        },
        onCardChange(data) {
            this.showCardPopup = false
            this.checkedCard = data
            this.onRefresh()
        },
    },
};
</script>

<style scoped lang="less">
::-webkit-scrollbar {
    display: none;
}
.mr-30 {
    margin-right: 50px;
}
.add-customer {
    height: 37px;
    font-size: 26px;
    color: #a0acb5;
    line-height: 37px;
    margin: 40px 0 40px 31px;
}
.add-customer-number {
    color: #f65252;
    font-weight: 700;
    font-size: 30px;
}
.van-pull-refresh {
    min-height: 100%;
}
.list-box {
    width: 100%;
    height: calc(100vh - 245px);
    justify-content: space-between;
    margin: 0 auto 0;
    position: relative;
    z-index: 1;
    overflow-y: auto;
    padding: 0 30px 30px 30px;
}

.customer-list {
    width: 690px;
    height: 200px;
    background: #fafafe;
    border-radius: 20px;
    margin-bottom: 20px;
    padding: 20px;
}
.customer-name {
    min-width: 60px;
    height: 42px;
    font-size: 30px;
    color: #35434c;
    line-height: 42px;
    font-weight: 700;
}
.churn-time {
    height: 37px;
    font-size: 26px;
    color: #a0acb5;
    line-height: 37px;
    margin-top: 11px;
}
.nursing-edit-box {
    margin: 37px 0 0 163px;
}
.arrow_right {
    width: 15px;
    height: 26px;
    margin-top: 10px;
}

.card-image {
    height: 34px;
    width: 90px;
    margin: 24px 0 0 10px;
}
.customerHeadPortrait {
    width: 90px;
    height: 90px;
    border-radius: 45px;
    margin-right: 20px;
}
.customer-remark {
    margin: 0 21px 0 20px;
}
.sale-name {
    height: 40px;
    font-size: 28px;
    color: #a0acb5;
    line-height: 40px;
    margin-top: 30px;
}
.sale-number {
    height: 45px;
    font-size: 28px;
    color: #35434c;
    line-height: 45px;
    margin-top: 28px;
    min-width: 40px;
    font-weight: 700;
}
.select-box {
    margin-left: 30px;
    .select-tit {
        font-size: 28px;
        color: #35434c;
    }
    .select-arrow {
        transform: rotate(90deg);
        font-size: 24px;
        margin-left: 10px;
    }
}

:deep(.van-search) {
    padding: 19px 20px 19px 20px;
}
:deep(.search-button .van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 3px 20px 0 0 !important;
    margin-right: 0 !important;
}

:deep(.van-icon__image) {
    height: 28px;
    display: inline-block;
}
:deep(.van-field__control) {
    font-size: 28px !important;
}
</style>

